import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

// Custom GCP "Network Interface" icon. The official Google Cloud icon
// set has no NIC glyph (per the Confluence `Cloud native icons` page —
// "I can't find any icon for this :crying_cat_face:"), so this is a
// codebase-original drawing kept inside the GCP visual language: the
// same `#4285F4 / #669DF6 / #AECBFA` blue palette used by `gcpVpc`,
// `gcpLb`, `gcpRouter`, `gcpServiceConnect`. Visually a NIC chassis
// with two RJ-45 jacks, four bottom pin leads, and a short connector
// tail — a deliberate echo of `azureNic` so cross-vendor diagrams read
// consistently for the user.
function createGcpNicIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <rect x="6" y="13" width="22" height="14" rx="1.6" fill="#4285F4"/>
    <rect x="9" y="15.5" width="6" height="8" rx="0.6" fill="#FFFFFF"/>
    <rect x="10" y="16.5" width="4" height="3.5" rx="0.3" fill="#4285F4"/>
    <rect x="10.4" y="21" width="0.9" height="1.6" fill="#4285F4"/>
    <rect x="12.7" y="21" width="0.9" height="1.6" fill="#4285F4"/>
    <rect x="17" y="15.5" width="6" height="8" rx="0.6" fill="#FFFFFF"/>
    <rect x="18" y="16.5" width="4" height="3.5" rx="0.3" fill="#4285F4"/>
    <rect x="18.4" y="21" width="0.9" height="1.6" fill="#4285F4"/>
    <rect x="20.7" y="21" width="0.9" height="1.6" fill="#4285F4"/>
    <rect x="8" y="27" width="2" height="2.4" rx="0.3" fill="#669DF6"/>
    <rect x="12" y="27" width="2" height="2.4" rx="0.3" fill="#669DF6"/>
    <rect x="16" y="27" width="2" height="2.4" rx="0.3" fill="#669DF6"/>
    <rect x="20" y="27" width="2" height="2.4" rx="0.3" fill="#669DF6"/>
    <rect x="24" y="27" width="2" height="2.4" rx="0.3" fill="#669DF6"/>
    <path d="M28 19.2 H32 V20.8 H28 Z" fill="#AECBFA"/>
    <circle cx="33.2" cy="20" r="1.8" fill="#AECBFA"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const gcpNicIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createGcpNicIcon,
);
